import React from 'react';
import { Chip } from '@heroui/react';
import { PlanInfo } from '@/types';

interface PlanBadgeProps {
	plan: PlanInfo;
	isActive: boolean;
}

const PlanBadge: React.FC<PlanBadgeProps> = ({ plan, isActive }) => (
    <div className="flex items-center justify-between w-full">
        <div className="flex-1">{plan.name}</div>
        {isActive && (
            <Chip size="sm" color="success" variant='primary' className="text-white">
                Active
            </Chip>
        )}
    </div>
);

export default PlanBadge;
